import {Directive, ElementRef, AfterViewInit} from '@angular/core';

@Directive({
  selector: '[focus]'
})
export class AutoFocus implements AfterViewInit {
  constructor(private el: ElementRef)
  {
  }
  ngAfterViewInit()
  {
    this.el.nativeElement.focus();
  }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/directive/autoFocus.directive.ts